module.exports = __webpack_public_path__ + "static/media/book-user.64bd26a0.svg";